export default __webpack_public_path__ + "static/media/sara.e2c9f29d.jpg";